/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CurrentProductListListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: CurrentProductListService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, HostBinding, EventEmitter, Input, Output, OnInit, ViewChild,
	trigger, transition, animate,
	style, state } from '@angular/core';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager }  from 'ng2-toastr';
import myGlobals = require('../globals');

import { CurrentProductListData, CurrentProductListService } from './CurrentProductList.service';
import { CurrentProductListSearchComponent }  from './CurrentProductListSearch.component';

@Component({
	selector: 'my-CurrentProductList',
	template: require('./CurrentProductListList.component.html'),
	providers: [CurrentProductListService],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.4s ease-in')
      ]),
      transition(':leave', [
        animate('0.7s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class CurrentProductListListComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}
	
	CurrentProductListList: CurrentProductListData[];
	newCurrentProductList: CurrentProductListData;
	selectedCurrentProductList: CurrentProductListData;
	errorMessage: string;
	messages: string[];
	showAdd: boolean;
	@ViewChild(CurrentProductListSearchComponent) filterComponent: CurrentProductListSearchComponent;

	sortExpression: string = "ProductID";
	filterExpression: string = "";
	pageIndex: number = 1;
	pageSize: number = 10;
	endRowIndex: number;
	rowsCount: number;
	pageCount: number;
	isFirstPage: boolean;

    private selectedId: string;

	constructor(
		private CurrentProductListService: CurrentProductListService,
		private route: ActivatedRoute,
		private router: Router,
		private toastr: ToastsManager
	) {
		this.newCurrentProductList = new CurrentProductListData();
		this.pageSize = myGlobals.pageSize;
	}

	ngOnInit() {
		// this.CurrentProductListService.getAll().subscribe(record => this.CurrentProductListList=record);
		this.pageIndex = 1;
		this.isFirstPage = true;
		this.getCurrentProductListByPaging();

		/*
		this.CurrentProductListList = this.route.params
			.switchMap((params: Params) => {
				this.selectedId = +params['id'];
				return this.service.getAll();
			});
		*/
	}

	// Get all records
	public getCurrentProductList() {
		this.CurrentProductListService.getAll()
			.subscribe(data => this.CurrentProductListList = data,
		error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error);
	}
	
	// On Search CLick on CurrentProductListSearch Component
	onSearch(searchText: string) {
		// 1. Update this.filterExpression
		this.filterExpression = searchText;

		// 2. call getCurrentProductListByPaging method that will refresh the data
		this.pageIndex = 1;
		this.getCurrentProductListByPaging();
	}
	
	onSort(event, sortColumn: string)
	{
		// var target = event.target || event.srcElement || event.currentTarget;
		// var parent = target.parentNode;
		if (this.sortExpression === sortColumn)
			this.sortExpression = sortColumn + ' desc';
		else if (this.sortExpression === sortColumn + ' desc')
			this.sortExpression = sortColumn;
		else
			this.sortExpression = sortColumn;
		this.getCurrentProductListByPaging();
	}
	
	// Get records by paging
	getCurrentProductListByPaging() {
		this.CurrentProductListService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
			.subscribe(data => {
				this.CurrentProductListList=data.CurrentProductListList;
				this.rowsCount=data.RowsCount; 
				this.pageCount= Math.ceil(this.rowsCount / this.pageSize);
				if (this.pageIndex == 1)
					this.isFirstPage = true;
				else
					this.isFirstPage = false;
				if (this.pageIndex == this.pageCount)
					this.endRowIndex = this.rowsCount;
				else
					this.endRowIndex = this.pageIndex * this.pageSize;
			},
			error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error
		);
	}
	// Adds new record
	addCurrentProductList() {
		this.CurrentProductListService.addCurrentProductListData(this.newCurrentProductList).subscribe(record => console.log(record));
		this.getCurrentProductList();
	}
  
	// Updates existing record
	updateCurrentProductList() {
		this.CurrentProductListService.updateCurrentProductListData(this.selectedCurrentProductList).subscribe(record => console.log(record));
		this.getCurrentProductList();
	}

	// Deletes record with specified id
	deleteCurrentProductList(id: string) {
		if (window.confirm('Are you sure you want to delete this CurrentProductList?') == true)
		{
			this.CurrentProductListService.deleteCurrentProductList(id)
			.subscribe(data => this.getCurrentProductList(), 
			error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error);
		}
	}

	// Go to First Page
	onFirstPage() {
		this.pageIndex = 1;
		this.getCurrentProductListByPaging();
	}

	// Go to Previous Page
	onPreviousPage() {
		if (this.pageIndex > 1) {
			this.pageIndex = this.pageIndex - 1;
			this.getCurrentProductListByPaging();
		}
	}

	// Go to Next Page
	onNextPage() {
		if (this.pageIndex < this.pageCount) {
			this.pageIndex = this.pageIndex + 1;
			this.getCurrentProductListByPaging();
		}
	}

	// Go to Last Page
	onLastPage() {
		this.pageIndex = this.pageCount;
		this.getCurrentProductListByPaging();
	}

	// Refresh - Go to First Page
	onRefresh() {
		this.onFirstPage();
	}

	// On Edit - Go to Edit page
	onSelect(item: CurrentProductListData) {
		this.router.navigate(['/CurrentProductList', item.ProductID]);
	}

	// On Details - Go to Details page
	onSelectDetails(item: CurrentProductListData) {
		this.router.navigate(['/CurrentProductList/Details', item.ProductID]);
	}

	// Set record as selected
	SelectCurrentProductList(item: CurrentProductListData) {
		this.selectedCurrentProductList = item;
	}

	// Submits form
	submitForm(data: Object) {
		console.log(data);
	}

	// Logs message onto Console
	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}

/*
	isSelected(item: CurrentProductListData) {
		return item.ProductID === this.selectedId;
	}
*/
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/CurrentProductList/CurrentProductListList.component.ts